import { useLocalizationContext } from '@order/Localization';

export function useSweetpassCheckoutContentfulInterpolation(
  values: InterpolateContentfulValues,
) {
  const {
    planPrice,
    trialDuration,
    trialDurationSingular,
    nextBillingDate,
    switchDate,
    ctaLabel,
    requestedPlanRecurrence,
    billingFrequencyUnit,
    billingFrequencyMembershipName,
  } = values;

  const { formatDate, formatPrice } = useLocalizationContext();

  const price =
    planPrice && !Number.isNaN(planPrice)
      ? formatPrice(planPrice * 100, 'USD')
      : '';

  const date = formatDate(new Date());

  return (field: string) =>
    field
      .replaceAll('{price}', price)
      .replaceAll('{date}', date)
      .replaceAll('{trialDuration}', trialDuration)
      .replaceAll('{trialDurationSingular}', trialDurationSingular)
      .replaceAll('{nextBillingDate}', formatDate(nextBillingDate))
      .replaceAll('{switchDate}', formatDate(switchDate))
      .replaceAll('{cta}', ctaLabel)
      .replaceAll('{requestedPlanRecurrence}', requestedPlanRecurrence)
      .replaceAll('{billingFrequencyUnit}', billingFrequencyUnit.toLowerCase())
      .replaceAll(
        '{billingFrequencyMembershipName}',
        billingFrequencyMembershipName,
      );
}

// ─── Types ───────────────────────────────────────────────────────────────────

type InterpolateContentfulValues = Readonly<{
  trialDuration: string;
  trialDurationSingular: string;
  planPrice: number;
  nextBillingDate: string;
  switchDate: string;
  ctaLabel: string;
  requestedPlanRecurrence: string;
  billingFrequencyUnit: string;
  billingFrequencyMembershipName: string;
}>;
